/**
 * the HTML5 autofocus property can be finicky when it comes to dynamically loaded
 * templates and such with AngularJS. Use this simple directive to
 * tame this beast once and for all.
 *
 * Usage:
 * <input type="text" autofocus>
 *
 * License: MIT
 *
 * Copypasta from https://gist.github.com/mlynch/dd407b93ed288d499778
 */

angular.module('am4').directive('autofocus', function($timeout) {
    return {
        restrict: 'A',
        link: function($scope, $element) {
            $timeout(function() {
                $element[0].focus();
            });
        }
    };
});



// WEBPACK FOOTER //
// ./src/app/directives/autofocus.js